var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a88865",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45 5.9c-1-.75-2.51-1.09-4.83-1.09H2.54v8.71h1.08a8.16 8.16 0 0 1 4.83 1.17ZM9.54 14.69a8.14 8.14 0 0 1 4.84-1.17h1.08V4.81h-1.08c-2.31 0-3.81.34-4.84 1.09Z",
    className: "icon-component-shadow",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.45 5.4c-1-.75-2.51-1.09-4.83-1.09H3V13h.58a8.1 8.1 0 0 1 4.83 1.17ZM9.54 14.19A8.14 8.14 0 0 1 14.38 13H15V4.31h-.58c-2.31 0-3.81.34-4.84 1.09Z",
    className: "icon-component"
  })));
};
export default SvgBook;